import 'react-app-polyfill/ie9'; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/style.css";
import App from "./App";
import HttpsRedirect from 'react-https-redirect';
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import {AppProvider} from "./AppContext"

ReactDOM.render(
    <HttpsRedirect>
      <AppProvider>
        <App />
      </AppProvider>
    </HttpsRedirect>
, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
